<script setup>
// Share My Schedule (My Schedule action bar — Phase 3). Figma node 4583:186106.
// Mints a read-only, shareable link to the user's My Schedule via
// GET /api/v1/schedule/calendar/links (the `share` field) and hands it to the
// shared FragmentsShare component for LinkedIn/Facebook/X + copy-link.
const emit = defineEmits(['close'])
const open = defineModel('open', { default: true })

const shareUrl = ref('')

// Best-effort fetch, same pattern as add-to-calendar.vue. FragmentsShare must
// NOT render until shareUrl resolves — it falls back to window.location.href
// (the owner's current page URL, not the share link) when :link is empty, so
// a fast click before the fetch lands would share/copy the WRONG url. Show a
// small branded loading affordance in its place instead (see the `working`
// state in add-to-calendar.vue).
onMounted(async () => {
    try {
        const links = await $fetch('/api/v1/schedule/calendar/links')
        shareUrl.value = links?.share || ''
    } catch (e) {
        // best-effort — leave shareUrl empty, FragmentsShare falls back to
        // window.location.href for each platform link.
    }
})

const close = () => { emit('close'); open.value = false }

// Same headline treatment as the other 2026 modals (add-to-calendar.vue).
const headlineCls = 'font-hubspot-serif font-normal text-[25px] sm:text-[30px] leading-[1.3] tracking-normal text-(--magenta) text-center m-0'

// This modal has no other primary action, so Close is the bordered pill
// (pillButtonCls convention), not the underline text link used when Close is
// a secondary action alongside a primary button — see find-a-session.vue's
// "Close is a bordered pill" note (confirmed live via get_design_context
// across the Single/Multiple Session results + Save-a-Seat Reminder modals).
const pillButtonCls = 'rounded-[50px] border border-(--magenta) text-(--magenta) px-[20px] py-[10px] font-hubspot-serif text-[17px] leading-[1.4] tracking-[0.34px] cursor-pointer transition-colors duration-200 hover:bg-(--magenta) hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--magenta)'
</script>

<template>
    <FragmentsModalShell v-model:open="open" title="Share your schedule" @close="close">
        <div class="flex flex-col gap-[45px] items-center w-full max-w-[681px] mx-auto">
            <h2 :class="headlineCls">Select how you'd like to share My Schedule:</h2>

            <div class="flex justify-center w-full">
                <FragmentsShare
                    v-if="shareUrl"
                    title="My UNBOUND Schedule"
                    :link="shareUrl"
                    label=""
                    :copyToClipboard="true"
                />
                <FragmentsLoading v-else :loading="true" />
            </div>
        </div>

        <template #actions>
            <button type="button" data-test="share-schedule-close" :class="pillButtonCls" @click="close">Close</button>
        </template>
    </FragmentsModalShell>
</template>
